// GraphSuite.jsx
import React, { useMemo } from 'react';

const GraphSuite = React.memo(({
  SuiteComponent,
  selectedSite,
  selectedCamera,
  selectedSuite,
  selectedYear,
  processedCameraData
}) => {
  // Memoize cameraId calculation to prevent unnecessary re-calculations
  const cameraId = useMemo(() => {
    if (selectedCamera === 'All') return 'All';
    return processedCameraData.find(c => c.camera_name === selectedCamera)?.camera_id;
  }, [selectedCamera, processedCameraData]);

  if (!SuiteComponent || !selectedSite || !selectedCamera) return null;

  return (
    <SuiteComponent
      selectedSite={selectedSite}
      selectedCamera={selectedCamera}
      selectedSuite={selectedSuite}
      selectedYear={selectedYear}
      selectedCameraId={cameraId}
      processedCameraData={processedCameraData}
    />
  );
}, (prevProps, nextProps) => {
  // Custom comparison function - only re-render if these specific props change
  return (
    prevProps.selectedSite?.hwid === nextProps.selectedSite?.hwid &&
    prevProps.selectedCamera === nextProps.selectedCamera &&
    prevProps.selectedSuite === nextProps.selectedSuite &&
    prevProps.selectedYear === nextProps.selectedYear &&
    prevProps.SuiteComponent === nextProps.SuiteComponent &&
    prevProps.processedCameraData.length === nextProps.processedCameraData.length
  );
});

GraphSuite.displayName = 'GraphSuite';

export default GraphSuite;
